import { gql } from "@apollo/client";

export const GET_EXPERIENCES = gql`
  query getExperiences($siteId: SiteID) {
    experiences(siteId: $siteId, searchType: "EMERCH") {
      totalCount
    }
  }
`;
